import { LOGO_PATHS, LOGO_OUTER } from "./logoPaths";

/* 3D 부품 색 — 쿠키커터 만들기 화면과 홈 2단계 카드가 같이 쓴다 */
export const PART_COLORS = { cutterWall: "#7ECFC0", cutterBase: "#9BCDF0", stampFace: "#F2A1B3", stampBase: "#F3E57C", handle: "#B08A55" };

/* 구성 버튼 아이콘 — 쿠키스토리 로고 모양에 3D 부품 색을 입힌다 (김현비 결정: 판다 대신 로고) */
export function ModeIcon({ kind }) {
  const detail = LOGO_PATHS.slice(2).map((p, i) => <path key={i} d={p.d} fill={PART_COLORS.stampFace} />);
  return (
    <svg className="ckc-mode-ic" viewBox="-34 -34 472 339" aria-hidden="true">
      {kind === "cutter" && (
        <path d={LOGO_OUTER} fill="none" stroke={PART_COLORS.cutterWall} strokeWidth="26" strokeLinejoin="round" />
      )}
      {kind === "stamp" && (
        <>
          <path d={LOGO_OUTER} fill={PART_COLORS.stampBase} stroke={PART_COLORS.stampBase} strokeWidth="26" strokeLinejoin="round" />
          {detail}
        </>
      )}
      {kind === "both" && (
        <>
          <path d={LOGO_OUTER} fill="none" stroke={PART_COLORS.cutterWall} strokeWidth="54" strokeLinejoin="round" />
          <path d={LOGO_OUTER} fill="currentColor" stroke="currentColor" strokeWidth="24" strokeLinejoin="round" />
          <path d={LOGO_OUTER} fill={PART_COLORS.stampBase} stroke={PART_COLORS.stampBase} strokeWidth="10" strokeLinejoin="round" />
          {detail}
        </>
      )}
    </svg>
  );
}

